import { createContext, useContext } from 'react';

/**
 * True for anything rendered inside the per-object details dialog.
 *
 * A `*Properties` component also renders in a row's hover panel, which
 * has neither the width for the dialog's lists nor a header of its own.
 * The dialog names the object, carries the actions in its header and
 * folds the identity block; the hover panel keeps its own heading and
 * shows the identity rows open, since it closes on any click.
 *
 * A context rather than a prop because the surfaces that differ are
 * rendered by `PropertiesPanel` and `IdentitySection`, several components
 * below whoever opened the dialog, and threading a flag through each
 * `*Properties` signature would put the same boolean in five component
 * APIs that have no other use for it.
 */
export const ObjectDetailsContext = createContext(false);

/** True when the caller is inside the per-object details dialog. */
export function useIsInObjectDetails(): boolean {
    return useContext(ObjectDetailsContext);
}
